/// <reference path="../baseClasses/dataMaintenance.interface.ts" />
/// <reference path="../baseClasses/dataServiceBase.ts" />
/// <reference path="../models/meevo.model.custom.ts" />

module Meevo.Components.Common {
    import ClientIndicatorEnum = Meevo.Model.ClientIndicatorEnum;

    export class ClientIndicatorsDataService extends Meevo.Components.BaseClasses.DataServiceBase implements Meevo.Components.BaseClasses.IDataService
    {
        public CLIENT_INDICATORS = {
            [ClientIndicatorEnum.ClientType]: {
                className: 'clienttype',
                order: 10,
                visibleFields: undefined,
                iconFile: ['assets/images/icons/client_type.svg']
            },
            [ClientIndicatorEnum.ClientCancelledOrNoShowAppt]: {
                className: 'cancelNoShowAlert',
                order: 20,
                visibleFields: null
            },
            [ClientIndicatorEnum.ClientPoints]: {
                className: 'clientpoints',
                order: 30,
                visibleFields: ["RemainingAmount", "RemainingPoints"]
            },
            [ClientIndicatorEnum.ClientMemberships]: {
                className: null, // conditional (ClientMembershipIndicatorStatusEnum)
                order: 40,
                visibleFields: ['MembershipDisplayName', 'ClientMembershipIndicatorStatus', 'AccruedServicesRemainingCount', 'MembershipBookingNote']
            },
            [ClientIndicatorEnum.ClientAccountBalance]: {
                className: null, // conditional (positive or negative)
                order: 50,
                visibleFields: null
            },
            [ClientIndicatorEnum.ClientPackages]: {
                className: null, // conditional (regular or unlimited)
                order: 60,
                visibleFields: null
            },
            [ClientIndicatorEnum.ClientGiftCards]: {
                className: 'giftcard',
                order: 70,
                visibleFields: ['LiabilityGiftCardCount', 'NonLiabilityGiftCardCount']
            },
            [ClientIndicatorEnum.ClientTransworld]: {
                className: 'transworld',
                order: 80,
                visibleFields: null
            },
            [ClientIndicatorEnum.ClientPaymentPlans]: {
                className: 'paymentplans',
                order: 90,
                visibleFields: ["Count"]
            },
            [ClientIndicatorEnum.ClientMinor]: {
                className: 'isminor',
                order: 100,
                visibleFields: undefined // unclickable
            },
            [ClientIndicatorEnum.ClientRestricted]: {
                className: 'isrestricted',
                order: 110,
                visibleFields: undefined // unclickable
            },
            [ClientIndicatorEnum.ClientPaymentAccounts]: {
                className: null,
                order: 120,
                visibleFields: ['ActiveAccounts', 'ExpiredAccounts'],
                iconFile: ['assets/images/icons/cc_onfile.svg', 'assets/images/icons/cc_onfile_expired.svg']
            },
            [ClientIndicatorEnum.ClientAlerts]: {
                className: 'normal',
                order: 130,
                visibleFields: null
            }
        };

        private promises: Record<string, ng.IPromise<any>> = {};

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $http: ng.IHttpService,
                    protected $q: ng.IQService,
                    protected $translate: angular.translate.ITranslateService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected $cookies: ng.cookies.ICookiesService,
                    protected busyService: Meevo.Components.Busy.BusyService) {
            super(appSettings, $http, $q, identityService, $cookies);

            //this.localStorageKey = `meevo2.client-indicators.${this.identityService.current().tenantId}.${this.identityService.current().locationId}`;
        }

        getItem<T>(key: string): any {
            super.getItem(key);
        }

        /**
         * Get list of indicators for client id
         * @param {Guid} clientId - clients id
         * @returns {array} List of Client Membership Indicators
         * @remarks Caches promises to not duplicate api calls for same clientId
         * */
         getClientIndicatorsData(clientId: string, indicators: any, includeClientHeaderData: boolean = true, cache = true): ng.IPromise<any> {
            if (!clientId || !indicators || indicators.length < 1) return this.$q.resolve(null);
            if (this.promises[clientId]) {
                return this.promises[clientId];
            }

            let cacheParam = cache ? '' : `&v=${new Date().getTime()}`;
            let clientIndicators = indicators.join(",");
            let uri = `/${this.appSettings.API_ROOT}/Client/${clientId}/Indicators?clientIndicators=${clientIndicators}&includeClientHeaderData=${includeClientHeaderData}${cacheParam}`;
            var clientIndicatorPromise = this.customMethodData(uri, "GET", null).then((response) => {
                delete this.promises[clientId];
                return <ClientIndicatorsDataService[]>response.data;
            });
            this.promises[clientId] = clientIndicatorPromise;
            return clientIndicatorPromise;

        }

        locallyStoreClientIndicators(indicators: any){

        }

        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings,
                       $http: ng.IHttpService,
                       $q: ng.IQService,
                       $translate: angular.translate.ITranslateService,
                       identityService: Meevo.Components.Common.IIdentityService,
                       $cookies: ng.cookies.ICookiesService,
                       busyService: Meevo.Components.Busy.BusyService) => {
                return new ClientIndicatorsDataService(appSettings, $http, $q, $translate, identityService, $cookies, busyService);
            };

            svc.$inject = [
                "meevo.AppSettings",
                "$http",
                "$q",
                "$translate",
                "meevo.components.common.IdentityService",
                "$cookies",
                "meevo.components.busy.BusyService"
            ];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.ClientIndicatorsDataService", ClientIndicatorsDataService.factory());
}
